export enum SMSSource {
  welcome = 'Welcome',
  remind1 = 'Remind1',
  remind2 = 'Remind2',
  campaign = 'Campaign'
}

export enum GoogleUTMCampaign {
  welcome = 'Welcome',
  remind1 = 'Remind1',
  remind2 = 'Remind2',
  campaign = 'Campaign'
}

export enum AppleCT {
  welcome = 'WelcomeSMS',
  remind1 = 'RemindSMS1',
  remind2 = 'RemindSMS2',
  campaign = 'CampaignSMS'
}
